
  import { Component, Vue } from 'vue-property-decorator'
  import Tasks from '../components/Tasks.vue'

  @Component({
    components: {
      Tasks
    }
  })

  export default class TasksList extends Vue {

  }
